import ProgressiveImage from "../components/ProgressiveBGImage/ProgressiveImage";
import { Footer } from "./Root";
import Abq2Md from "../assets/abq-2-md.jpg";
import Abq2Sm from "../assets/abq-2-sm.jpg";
import { MiniIssues } from "../components/MiniIssues";
import Endorsements from "../components/Endorsements";
import { About } from "./About";
import Logo from "../assets/LukeforNMfinalnobg.png"

export const Home = () => {
  return (
    <div
      className={
        "flex flex-1 flex-col overflow-x-hidden items-start w-full pt-[112px] lg:pt-[96px]"
      }
    >
      <ProgressiveImage
        src={Abq2Md}
        placeholderSrc={Abq2Sm}
        className="w-full h-[100vh]"
      >
        <div
          className={
            "flex flex-col items-center justify-between w-full bg-gradient-to-b from-blue-50/60 to-blue-50 min-h-[90vh]"
          }
        >
          <div className="flex flex-col items-center justify-center p-4">
            <img className={"max-w-full w-[500px] lg:w-[700px]"} src={Logo} alt={"Luke Jungmann Logo"} />
            <div className="text-[#b02d18] text-center font-sans font-bold text-[2.5rem] lg:text-[4rem] leading-10">
              FOR NM HOUSE SEAT 60
            </div>
          </div>
          <div
            className={
              "flex flex-col-reverse lg:flex-row items-center lg:items-end relative w-full"
            }
          >
            <div
              className={
                "text-black text-xl lg:text-4xl p-4 lg:pl-8 pb-16 lg:py-24 flex-1 z-10 w-full"
              }
            >
              <div className="text-4xl lg:text-6xl border-b-2 border-b-black/80">
                {" "}
                Luke Jungmann
              </div>
              <div>Democrat + Democratic Socialist</div>
              <div className="text-base lg:text-xl">Running for:</div>
              <b>
                New Mexico House of Representatives District 60 in Rio Rancho
              </b>
            </div>
            <img
              className={
                "flex-1 h-max w-full max-w-[600px] lg:w-1/2 -scale-x-100 pointer-events-none rounded-b-full overflow-hidden"
              }
              src={"images/Luke-3214-med-res.png"}
              alt="Luke"
            />
          </div>
        </div>
      </ProgressiveImage>
      <div
        className={
          "relative min-h-max flex flex-col items-center lg:py-32 py-16 align-bottom w-full bg-blue-50"
        }
      >
        <div className="text-5xl pb-16 lg:pb-0 lg:text-6xl text-center">
          What we're fighting for:
        </div>
      </div>
      <MiniIssues />
      <div
        className={
          "relative min-h-max flex flex-col items-center lg:py-32 py-16 align-bottom w-full bg-sky-200/95 backdrop-blur-sm"
        }
      >
        <div className="text-5xl lg:text-6xl text-center">Endorsements</div>
      </div>
      <Endorsements />
      <About />
      <Footer />
    </div>
  );
};
